if (!window.location.pathname.includes("admin")) {
  document.querySelectorAll(".trix-button-group--file-tools").forEach(button => button.remove());
}
